import { get_reservation_details } from "./instantBook/instantBook_api";

$("[view_reservation]").on("click", function() {
    const reservationId_str:string|undefined = $(this).attr("reservationId");
    if (reservationId_str == undefined) return;
    const reservationId:number = parseInt(reservationId_str);

    const collapse:JQuery<HTMLElement> = $(`[reservationDetails][reservationId="${reservationId}"]`);

    if (collapse.html().length == 0) {

        get_reservation_details(reservationId).then(reservationHtml => {

            collapse.html(reservationHtml);
            collapse.collapse("show");
        }).catch(e => {
            console.error(e);
        })
    } else {
        collapse.collapse("toggle");
    }
});